/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiPublicSiteDtoEditableCustomListDto
 */
export interface WebApiPublicSiteDtoEditableCustomListDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiPublicSiteDtoEditableCustomListDto
     */
    customListId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoEditableCustomListDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoEditableCustomListDto interface.
 */
export function instanceOfWebApiPublicSiteDtoEditableCustomListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoEditableCustomListDtoFromJSON(json: any): WebApiPublicSiteDtoEditableCustomListDto {
    return WebApiPublicSiteDtoEditableCustomListDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoEditableCustomListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoEditableCustomListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customListId': !exists(json, 'customListId') ? undefined : json['customListId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function WebApiPublicSiteDtoEditableCustomListDtoToJSON(value?: WebApiPublicSiteDtoEditableCustomListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customListId': value.customListId,
        'name': value.name,
    };
}

